import { useContext } from 'react'
import { AuthContext } from '../../../../Auth/AuthContext'
import ContentHeader from '../../../Layout/ContentHeader'
import DashboardActivityWaterTruckRequest from '../../Catalogs/WaterTruckRequest/components/Dashboard/DashboardActivityWaterTruckRequest'

const ReportsCountersPipes = () => {
  //STATES
  const { user } = useContext(AuthContext)

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <h1 className="header-title">
            Bienvenido{user.name ? `, ${user.name}` : ''}
          </h1>
        }
        breadcrumb=""
        windowTitle="Dashboard"
      />

      <DashboardActivityWaterTruckRequest />
    </>
  )
}

export default ReportsCountersPipes
